export default function spanishHumanReadableTime(
  years: number,
  months: number,
) {
  let returnString = ''
  if (years > 0) {
    returnString += `${years} año${years > 1 ? 's' : ''}`
  }
  if (months > 0) {
    returnString += `${years > 0 ? ' and ' : ''}${months} mes${months > 1 ? 'es' : ''}`
  }
  return returnString
}
